import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=5938c634"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports